import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../../common/CmnContext';
import { LiveReserveContext } from '../../../LiveLessonReseveContext';
import LiveReserveSelectInstructorModalHead from './head/LiveReserveSelectInstructorModalHead';
import LiveReserveSelectInstructorModalSelected from './selected/LiveReserveSelectInstructorModalSelected';
import LiveReserveSelectInstructorModalItem from './item/LiveReserveSelectInstructorModalItem';


function LiveReserveSelectInstructorModal(props: any) {

  const isPc = useContext(cmnContext).isPc;
  const { instructors, noSlotInstructors } = useContext(LiveReserveContext);

  const selectInst = props.selectInst;
  const setIsDispModal = props.setIsDispModal;
  // 講師情報から画像取得
  const getInstImg = props.getInstImg;
  // 講師の趣味・スコア情報
  const getInstDetailInfo = props.getInstDetailInfo;

  const listRef = useRef<HTMLDivElement>(null);
  const [listWidth, setListWidth] = useState<number>(0);
  // 空き枠の無い講師も一覧に出すか (SPEAKOUT-1853)
  const [isDispNoSlot, setIsDispNoSlot] = useState<boolean>(false);

  // 空き枠の無い講師はサーバーが別に返している（予約用の一覧からは外れている）
  const dispInstructors = isDispNoSlot
    ? (instructors || []).concat(noSlotInstructors || [])
    : (instructors || []);


  useEffect(() => {
    if (listRef.current) {
      setListWidth(listRef.current.offsetWidth);
      // 画面リサイズにも対応したい場合
      const handleResize = () => setListWidth(listRef.current!.offsetWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);



  return (
    <div style={{backgroundColor: '#fff'}}>

      {/* header */}
      <LiveReserveSelectInstructorModalHead
        setIsDispModal={setIsDispModal}
      />

      {/* 選択中 */}
      {selectInst &&
        <LiveReserveSelectInstructorModalSelected
          selectInst={selectInst}
        />
      }

      {/* ★SPEAKOUT-1853 空き枠の無い講師をここから出す。
          この一覧(instructors)は「今すぐ予約できる枠がある講師」だけなので、
          休止中や枠を出していない講師は選べない＝その講師へリクエストする道が無かった。
          選ぶと日程欄が自動で希望日時のリクエストに切り替わる。 */}
      {(noSlotInstructors && noSlotInstructors.length > 0) &&
        <div className="text-right" style={{margin: '0 10px 5px 0'}}>
          <div
            className={isDispNoSlot ? 'btn btn-default' : 'btn btn-info'}
            style={{padding: '5px 10px', fontSize: '80%', whiteSpace: 'normal'}}
            onClick={() => setIsDispNoSlot(!isDispNoSlot)}
          >
            {isDispNoSlot
              ? '⇒ 空き枠のある講師だけ表示'
              : '⇒ 希望の講師が見つからない場合'}
          </div>
        </div>
      }

      {/* 一覧 */}
      <div
        ref={listRef}
        className='row'
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexGrow: 1,
          overflowY: 'auto',
          paddingRight: '5px',
          margin: 0,
        }}
      >
        {dispInstructors.map((inst: any, index: number) => {
          const rowIndex = isPc ? Math.floor(index / 2) : index;
          const bgColor = rowIndex % 2 === 0 ? '#f8f8f8' : '#ffffff'; // 交互に色変更

          return (
            <div
              key={inst.inst_id}
              className="col-xs-12 col-sm-6"
              style={{ backgroundColor: bgColor }}
            >
              <LiveReserveSelectInstructorModalItem
                inst={inst}
                setIsDispModal={setIsDispModal}
                listWidth={listWidth}
                getInstImg={getInstImg}
                getInstDetailInfo={getInstDetailInfo}
              />
            </div>
          );
        })}
      </div>

    </div>
  );
}
  
export default LiveReserveSelectInstructorModal;